$(function(){

    var useTextarea=$("<textarea></textarea>");


    $(".copy-content").each(function(i,content) {
        $(content).on("click",function(e){
            var position=$(this).offset();
            var width=$(this).width();

            useTextarea[0].value=$(this).text();
            document.body.appendChild(useTextarea[0]);
            useTextarea[0].select();

            try {
                var successful = document.execCommand('copy');
                var msg = successful ? 'successful' : 'unsuccessful';
                console.log('Copying text command was ' + msg ,useTextarea.text());
            } catch (err) {
                console.log('Oops, unable to copy');
            }

            document.body.removeChild(useTextarea[0]);

            var ghost=$('<div class="copied">Copy to clipboard</div>');
            $("body").append(ghost);
            ghost.css({top:position.top+"px",left:position.left+"px"}).animate({top:position.top-20+"px",opacity:0},500,function(){ $(this).remove(); });

            e.preventDefault();
            return false;
        });
    });

});